<template>
  <IviewModal v-bind="$attrs" @on-cancel="close" title="配置模块" @on-ok="save" size="large" @on-visible-change="open">
    <div class="node-content">
      <div class="form-item">
        <div class="label">组织树名称 :</div>
        <span>{{ data.nodeName }}</span>
      </div>
      <div class="form-item">
        <div class="label"><i class="required"></i>选择模块 :</div>
      </div>
      <div class="model-wrap">
        <div class="check">
          <IviewCheckbox :value="selectArr.length>=moduleList.length" @on-change="allChange">全部</IviewCheckbox>
          <IviewCheckboxGroup v-model="selectArr" :optionList="moduleList" @on-change="moduleAllChange" />
        </div>
        <div class="top">
          <el-radio-group v-model="form.currentModule" size="small">
            <el-radio-button :label="item.label" v-for="(item, i) in moduleArr" :key="i">{{
              item.label
            }}</el-radio-button>
          </el-radio-group>
          <div class="line"></div>
          <IviewCheckboxGroup v-model="form.ptArr" :optionList="treeData" />
        </div>
        <ul class="tree-list">
          <li v-for="(item, i) in treeData" :key="item.label" v-show="form.ptArr.includes(item.label)">
            <div class="t1">{{ item.label }}</div>
            <div v-for="(tree, k) in item.tree" :key="k">
              <IviewTree2
                v-show="form.currentModule == tree.title"
                v-model="tree.treeCode"
                :treeData="[tree]"
                ref="tree"
              />
            </div>
            <div v-if="!item.tree.find((item) => item.title == form.currentModule)" class="no-tree">暂无数据</div>
          </li>
        </ul>
      </div>
    </div>
  </IviewModal>
</template>

<script>
export default {
  props: {
    data: {
      type: Object,
      default: () => ({})
    }
  },
  data() {
    return {
      form: {
        currentModule: '',
        nodeName: '',
        orgLevel: '',
        treeCode: [],
        ptArr: this.$root.permissionTree.map((item) => item.name) //勾选的平台
      },
      selectArr: [],
      treeData: [], //真正渲染的tree数据
      permissionTree: this.$root.permissionTree,
      moduleList: this.$root.permissionModules, //从主应用接收到的模块
      moduleArr: [] //选择模块中勾选中的模块数组
    }
  },
  created() {
    this.treeData = this.permissionTree.map((item) => ({
      label: item.name,
      value: item.name,
      tree: item.tree.map((tree) => ({ ...tree, treeCode: [] }))
    }))
  },
  methods: {
    // 打开时
    open(bool) {
      if (bool) {
        // 获取权限
        this.$api.config.getNodeAssoc({}, [this.data.orgLevel]).then((res) => {
          this.treeData.map((item) => item.tree.map((item2) => (item2.treeCode = res.data)))
        })
        // 获取模块
        this.$api.config.getNodeAttr({}, [this.data.orgLevel]).then((res) => {
          if (res.data[0]) {
            this.selectArr = JSON.parse(res.data[0].attributeContent)
            this.getModuleArr()
          } else {
            this.selectArr = []
          }
        })
        this.form.currentModule = ''
      }
    },
    // 模块复选框变化时
    moduleAllChange() {
      this.getModuleArr()
    },
    allChange(bool) {
      if (bool) {
        this.selectArr = this.moduleList.map((item) => item.label)
      } else {
        this.selectArr = []
      }
      this.moduleAllChange()
    },
    async save() {
      // 保存权限code
      let codes = []
      this.$refs.tree.map((item) => {
        codes.push(...item.getNodes())
      })
      await this.$api.config.putNodeAssoc(codes, [this.data.orgLevel])
      // 保存模块
      this.$api.config
        .putNodeAttr(
          [{ orgLevel: this.data.orgLevel, type: 1, attributeContent: JSON.stringify(this.selectArr) }],
          [this.data.orgLevel]
        )
        .then((res) => {
          this.$Message.success('保存成功')
          this.close()
        })
    },
    // 获取模块单选按钮
    getModuleArr() {
      let obj = {}
      this.selectArr.map((item) => (obj[item] = true))
      this.moduleArr = this.moduleList.filter((item) => obj[item.label])
      if(!this.form.currentModule&&this.moduleArr.length>0){
        this.form.currentModule=this.moduleArr[0].value
      }
    },
    close() {
      this.$emit('input', false)
    }
  }
}
</script>

<style lang="less" scoped>
.node-content {
  .form-item {
    display: flex;
    align-items: center;
    margin-top: 20px;
    font-size: 14px;
    .label {
      margin-right: 8px;
    }
  }
  .form-item:nth-child(1) {
    color: #333;
    font-size: 18px;
  }
  .model-wrap {
    background: #f6f8fb;
    margin: 20px 30px 0;
    padding-bottom: 10px;
    position: relative;
    .check {
      position: absolute;
      left: 60px;
      top: -38px;
      display: flex;
      align-items: center;
    }
    .top {
      height: 64px;
      background: #ffffff;
      box-shadow: 0px 3px 2px 0px rgba(0, 0, 0, 0.03);
      border-radius: 2px 2px 0px 0px;
      border: 1px solid #e9edf2;
      display: flex;
      align-items: center;
      padding: 0 30px;
      .line {
        width: 1px;
        height: 20px;
        background: #d7dfee;
        margin: 0 16px;
      }
    }
    .tree-list {
      margin: 12px 15px;
      display: flex;
      width: 1140px;
      li {
        background: #fff;
        flex: 1;
        margin: 0 6px;
        box-shadow: 0px 2px 4px 0px rgba(0, 0, 0, 0.14);
        border-radius: 2px;
        position: relative;
        .t1 {
          height: 40px;
          line-height: 40px;
          border-bottom: 1px solid #e8ebf1;
          font-size: 14px;
          font-family: Helvetica;
          color: #333333;
          padding-left: 20px;
        }
        .i-tree {
          padding: 20px 10px;
        }
        .no-tree {
          padding: 10px;
          // position: absolute;
          // left: 0;
          // right: 0;
          // top: 40px;
          // box-shadow: 0px 2px 4px 0px rgba(0, 0, 0, 0.14);
        }
      }
    }
  }
}
</style>
